import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { history, useIntl } from 'umi';
import { Button, Table } from 'tea-component';
import '@/pages/intelligence/assets/scss/MarketProfile/TabDetails/Stats.scss';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import '@/pages/intelligence/pages/MarketProfile/TabDetails/Stats/index.scss';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import AppAnnie from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
import sensortower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import { DataSourceBubbleContent } from '@/pages/intelligence/components/DataSourceBubbleContent';
import ApnnieNochange from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import defaltCountryImg from '@/pages/home/assets/img/flag/default.svg';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import xbox from '@/pages/intelligence/assets/svg/marketprofile/xbox.svg';
import playstation from '@/pages/intelligence/assets/svg/marketprofile/playstation.svg';
import nintendo from '@/pages/intelligence/assets/svg/marketprofile/nintendo.svg';
import mscience32 from '@/pages/intelligence/assets/svg/marketprofile/mscience32.svg';
import npd from '@/pages/intelligence/assets/svg/dataSource/npd.svg';
import newzoo from '@/pages/home/assets/svg/dataSource/databarin.svg';
// import newzoo from '@/pages/intelligence/assets/svg/marketprofile/newzoonew.svg';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import Loading from '@/pages/intelligence/components/Loading';
const { scrollable, pageable } = Table.addons;
export default function GameTable(props: any) {
  const {
    dateType,
    showTableData,
    changeTableSort,
    sortColunms,
    sortOrder,
    gameType,
    selectedKeys,
    selectedAllKeys,
    changeSelectedKeys,
    changeSelectedKeysColor,
    onPagingChange,
    dataType,
    tableLength,
    pageSize,
    pageIndex,
    onGamesSortChange,
    tableDataLoad,
  } = props;
  const { formatMessage } = useIntl();
  const formatGenreColumnValue = (displayValue: string[] | string, rawValue: string[] | string) => {
    const genreValue = displayValue || rawValue;

    if (Array.isArray(genreValue)) {
      return genreValue.length > 0 ? genreValue.join(' | ') : '-';
    }

    return genreValue || '-';
  };
  const color = [
    '#376AE7',
    '#3ECBFF',
    '#4FCB87',
    '#FFD14E',
    '#ED9142',
    '#E95F6A',
    '#CF61AC',
    '#8164CD',
    '#6585F7',
    '#A0B6FA',
    '#3ba272',
  ];
  const pcColor = [
    '#376AE7',
    '#3ECBFF',
    '#4FCB87',
    '#FFD14E',
    '#ED9142',
    '#E95F6A',
    '#CF61AC',
    '#8164CD',
    '#6585F7',
    '#A0B6FA',
    '#3ba272',
  ];

  // 跳转到游戏详情
  const gotoGameDetailsPage = (val: any, jump = true) => {
    const path = getDetailGamePathCommon({
      entityType: gameType,
      gameId: val.app_id,
      tab: 'overview',
    });
    if (jump) {
      buriedBtnPoint(dbiBtnLogMes.marketProfileStatsClickGame);
      return history.push(path);
    }
    return path;
  };

  const tableColumns = [
    {
      key: 'select',
      width: 37,
      fixed: 'left',
      header: () => {
        return (
          <TableCheckboxHeader
            selectList={selectedKeys}
            tableSelectionAll={selectedAllKeys}
            onChange={(list, type) => {
              if (type == 'all') return;
              changeSelectedKeysColor({});
              selectedKeys.length = 0;
              changeSelectedKeys([...selectedKeys]);
            }}
          />
        );
      },
      render: (cvm: any) => {
        return (
          <TableCheckboxRender
            selectList={selectedKeys}
            cvm={{ ...(cvm || {}), gameId: cvm?.app_id }}
            // allSelectColor={selectedKeysColor}
            onChange={(list, status) => {
              changeSelectedKeys(list);
              const selectedKeysColorTemp = [] as any;

              list.forEach((item, index) => {
                if (list.length < 6) {
                  let itemColor = '';
                  if (gameType == 'mobile') {
                    itemColor = color[index];
                  } else {
                    itemColor = pcColor[index];
                  }
                  selectedKeysColorTemp[item.app_id] = itemColor;
                }
              });
              changeSelectedKeysColor(selectedKeysColorTemp);
            }}
          />
        );
      },
    },
    {
      width: 300,
      key: 'id',
      header: (
        <div className="dbi-firstRow-flex">
          <span className="dbi-text-id">#</span>
          <span>{formatMessage({ id: 'dbi_game' })}</span>
        </div>
      ),
      fixed: 'left',
      render: (cvm: any) => (
        <FirstRow
          id={cvm.rank}
          cvm={{
            imgType: gameType,
            gametitle: cvm.name,
            img: cvm.gameIcon,
            countryIcon: cvm.conutryFlag || defaltCountryImg,
            text: cvm.desc,
          }}
          onClick={() => gotoGameDetailsPage(cvm)}
          rihgtClickToJumpHref={gotoGameDetailsPage(cvm, false)}
        />
      ),
    },
    {
      key: 'revenueA',
      align: 'right',
      header: (
        <SortBy
          // type="font_sort"
          title={formatMessage({ id: 'dbi_revenue_$' })}
          svgIcon={AppAnnie}
          filter={changeTableSort}
          defaultKey={sortColunms[0]}
          defaultValue={sortOrder?.[sortColunms[0]] || 'desc'}
          onChange={onGamesSortChange}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={formatMessage({ id: 'dbi_revenue_$' })}
              metric={'appannie'}
              metricKey={'revenue'}
              entityType={gameType}
            />
          }
          content={
            <div style={{ maxWidth: '418px' }}>
              {formatMessage({ id: 'dbi_info_sum_selected' })}
              <br />
              {formatMessage({ id: 'dbi_info_revenue_removed' })}
              <br />
              {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
            </div>
          }
          list={[
            {
              key: `gameRevenueA`,
              text: formatMessage({ id: 'dbi_revenue_$' }),
              title: formatMessage({ id: 'dbi_revenue_$' }),
            },
            {
              key: `gameRevenueAChange`,
              text: `${formatMessage({ id: 'dbi_revenue_$' })}:${formatMessage({
                id: 'dbi_change',
              })}(%)`,
              title: `${formatMessage({ id: 'dbi_revenue_$' })}%`,
            },
          ]}
        />
      ),
      render: (cvm: any) => (
        <TableShowData
          value={cvm.revenueAppannie == 0 ? '-' : formatNum(cvm.revenueAppannie, true)}
          type={cvm.revenueAppannieChange > 0 ? 'up' : cvm.revenueAppannieChange < 0 ? 'down' : ''}
          growth={
            cvm.revenueAppannieChange == 0 ? '-' : formatPercentNum(cvm.revenueAppannieChange)
          }
        />
      ),
    },
    {
      key: 'revenueS',
      align: 'right',
      header: (
        <SortBy
          // type="font_sort"
          title={formatMessage({ id: 'dbi_revenue_$' })}
          svgIcon={sensortower}
          filter={changeTableSort}
          defaultKey={sortColunms[0]}
          onChange={onGamesSortChange}
          defaultValue={sortOrder?.[sortColunms[0]] || 'desc'}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={formatMessage({ id: 'dbi_revenue_$' })}
              metric={'sensortower'}
              metricKey={'revenue'}
              entityType={gameType}
            />
          }
          content={
            <div style={{ maxWidth: '418px' }}>
              {formatMessage({ id: 'dbi_info_sum_selected' })}
              <br />
              {formatMessage({ id: 'dbi_info_revenue_removed' })}
              <br />
              {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
            </div>
          }
          list={[
            {
              key: `gameRevenueS`,
              text: formatMessage({ id: 'dbi_revenue_$' }),
              title: formatMessage({ id: 'dbi_revenue_$' }),
            },
            {
              key: `gameRevenueSChange`,
              text: `${formatMessage({ id: 'dbi_revenue_$' })}:${formatMessage({
                id: 'dbi_change',
              })}(%)`,
              title: `${formatMessage({ id: 'dbi_revenue_$' })}%`,
            },
          ]}
        />
      ),
      render: (cvm: any) => (
        <TableShowData
          value={cvm.revenueSensor == 0 ? '-' : formatNum(cvm.revenueSensor, true)}
          type={cvm.revenueSensorChange > 0 ? 'up' : cvm.revenueSensorChange < 0 ? 'down' : ''}
          growth={cvm.revenueSensorChange == 0 ? '-' : formatPercentNum(cvm.revenueSensorChange)}
        />
      ),
    },
    {
      key: 'downloadA',
      align: 'right',
      header: (
        <SortBy
          // type="font_sort"
          title={formatMessage({ id: 'dbi_downloads' })}
          svgIcon={AppAnnie}
          filter={changeTableSort}
          defaultKey={sortColunms[0]}
          onChange={onGamesSortChange}
          defaultValue={sortOrder?.[sortColunms[0]] || 'desc'}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={formatMessage({ id: 'dbi_downloads' })}
              metric={'appannie'}
              metricKey={'download'}
              entityType={gameType}
            />
          }
          content={
            <>
              {formatMessage({ id: 'dbi_info_sum_selected' })}
              <br />
              {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
            </>
          }
          list={[
            {
              key: `gameDownloadA`,
              text: formatMessage({ id: 'dbi_downloads' }),
              title: formatMessage({ id: 'dbi_downloads' }),
            },
            {
              key: `gameDownloadAChange`,
              text: `${formatMessage({ id: 'dbi_downloads' })}:${formatMessage({
                id: 'dbi_change',
              })}(%)`,
              title: `${formatMessage({ id: 'dbi_downloads' })}%`,
            },
          ]}
        />
      ),
      render: (cvm: any) => (
        <TableShowData
          value={cvm.downloadsAppannie == 0 ? '-' : formatNum(cvm.downloadsAppannie, true)}
          type={
            cvm.downloadsAppannieChange > 0 ? 'up' : cvm.downloadsAppannieChange < 0 ? 'down' : ''
          }
          growth={
            cvm.downloadsAppannieChange == 0 ? '-' : formatPercentNum(cvm.downloadsAppannieChange)
          }
        />
      ),
    },
    {
      key: 'downloadS',
      align: 'right',
      header: (
        <SortBy
          // type="font_sort"
          title={formatMessage({ id: 'dbi_downloads' })}
          svgIcon={sensortower}
          filter={changeTableSort}
          defaultKey={sortColunms[0]}
          defaultValue={sortOrder?.[sortColunms[0]] || 'desc'}
          onChange={onGamesSortChange}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={formatMessage({ id: 'dbi_downloads' })}
              metric={'sensortower'}
              metricKey={'download'}
              entityType={gameType}
            />
          }
          content={
            <>
              {formatMessage({ id: 'dbi_info_sum_selected' })}
              <br />
              {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
            </>
          }
          list={[
            {
              key: `gameDownloadS`,
              text: formatMessage({ id: 'dbi_downloads' }),
              title: formatMessage({ id: 'dbi_downloads' }),
            },
            {
              key: `gameDownloadSChange`,
              text: `${formatMessage({ id: 'dbi_downloads' })}:${formatMessage({
                id: 'dbi_change',
              })}(%)`,
              title: `${formatMessage({ id: 'dbi_downloads' })}(%)`,
            },
          ]}
        />
      ),
      render: (cvm: any) => (
        <TableShowData
          value={cvm.downloadsSensor == 0 ? '-' : formatNum(cvm.downloadsSensor, true)}
          type={cvm.downloadsSensorChange > 0 ? 'up' : cvm.downloadsSensorChange < 0 ? 'down' : ''}
          growth={
            cvm.downloadsSensorChange == 0 ? '-' : formatPercentNum(cvm.downloadsSensorChange)
          }
        />
      ),
    },
    {
      key: 'MAU',
      align: 'right',
      header: (
        <SortBy
          // type="font_sort"
          title={
            dateType == 'month'
              ? formatMessage({ id: 'dbi_mau' })
              : dateType == 'week'
              ? formatMessage({ id: 'dbi_wau' })
              : formatMessage({ id: 'dbi_dau' })
          }
          svgIcon={ApnnieNochange}
          filter={changeTableSort}
          defaultKey={sortColunms[0]}
          defaultValue={sortOrder?.[sortColunms[0]] || 'desc'}
          onChange={onGamesSortChange}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={`${
                dateType == 'month'
                  ? formatMessage({ id: 'dbi_mau' })
                  : dateType == 'week'
                  ? formatMessage({ id: 'dbi_wau' })
                  : formatMessage({ id: 'dbi_dau' })
              }`}
              metric={'appannie'}
              metricKey={'mau'}
              entityType={gameType}
            />
          }
          content={
            <>
              {formatMessage({ id: 'dbi_info_avg_selected' })}
              <br />
              {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
            </>
          }
          list={[
            {
              key: `gameMAUA`,
              text:
                dateType == 'month'
                  ? formatMessage({ id: 'dbi_mau' })
                  : dateType == 'week'
                  ? formatMessage({ id: 'dbi_wau' })
                  : formatMessage({ id: 'dbi_dau' }),
              title:
                dateType == 'month'
                  ? formatMessage({ id: 'dbi_mau' })
                  : dateType == 'week'
                  ? formatMessage({ id: 'dbi_wau' })
                  : formatMessage({ id: 'dbi_dau' }),
            },
            {
              key: `gameMAUAChange`,
              text: `${
                dateType == 'month'
                  ? formatMessage({ id: 'dbi_mau' })
                  : dateType == 'week'
                  ? formatMessage({ id: 'dbi_wau' })
                  : formatMessage({ id: 'dbi_dau' })
              }:${formatMessage({ id: 'dbi_change' })}(%)`,
              title: `${
                dateType == 'month'
                  ? formatMessage({ id: 'dbi_mau' })
                  : dateType == 'week'
                  ? formatMessage({ id: 'dbi_wau' })
                  : formatMessage({ id: 'dbi_dau' })
              }(%)`,
            },
          ]}
        />
      ),
      render: (cvm: any) => (
        <TableShowData
          value={cvm.MAUAppannie == 0 ? '-' : formatNum(cvm.MAUAppannie, true)}
          type={cvm.MAUAppannieChange > 0 ? 'up' : cvm.MAUAppannieChange < 0 ? 'down' : ''}
          growth={cvm.MAUAppannieChange == 0 ? '-' : formatPercentNum(cvm.MAUAppannieChange)}
        />
      ),
    },
    {
      key: 'MAUS',
      align: 'right',
      header: (
        <SortBy
          // type="font_sort"
          title={
            dateType == 'month'
              ? formatMessage({ id: 'dbi_mau' })
              : dateType == 'week'
              ? formatMessage({ id: 'dbi_wau' })
              : formatMessage({ id: 'dbi_dau' })
          }
          svgIcon={sensortower}
          filter={changeTableSort}
          defaultKey={sortColunms[0]}
          defaultValue={sortOrder?.[sortColunms[0]] || 'desc'}
          onChange={onGamesSortChange}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={
                dateType == 'month'
                  ? formatMessage({ id: 'dbi_mau' })
                  : dateType == 'week'
                  ? formatMessage({ id: 'dbi_wau' })
                  : formatMessage({ id: 'dbi_dau' })
              }
              metric={'sensortower'}
              metricKey={'mau'}
              entityType={gameType}
            />
          }
          content={
            <>
              {formatMessage({ id: 'dbi_info_avg_selected' })}
              <br />
              {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
            </>
          }
          list={[
            {
              key: `gameMAUS`,
              text:
                dateType == 'month'
                  ? formatMessage({ id: 'dbi_mau' })
                  : dateType == 'week'
                  ? formatMessage({ id: 'dbi_wau' })
                  : formatMessage({ id: 'dbi_dau' }),
              title:
                dateType == 'month'
                  ? formatMessage({ id: 'dbi_mau' })
                  : dateType == 'week'
                  ? formatMessage({ id: 'dbi_wau' })
                  : formatMessage({ id: 'dbi_dau' }),
            },
            {
              key: `gameMAUSChange`,
              text: `${
                dateType == 'month'
                  ? formatMessage({ id: 'dbi_mau' })
                  : dateType == 'week'
                  ? formatMessage({ id: 'dbi_wau' })
                  : formatMessage({ id: 'dbi_dau' })
              }:${formatMessage({ id: 'dbi_change' })}(%)`,
              title: `${
                dateType == 'month'
                  ? formatMessage({ id: 'dbi_mau' })
                  : dateType == 'week'
                  ? formatMessage({ id: 'dbi_wau' })
                  : formatMessage({ id: 'dbi_dau' })
              }(%)`,
            },
          ]}
        />
      ),
      render: (cvm: any) => (
        <TableShowData
          value={cvm.MAUSensor == 0 ? '-' : formatNum(cvm.MAUSensor, true)}
          type={cvm.MAUSensorChange > 0 ? 'up' : cvm.MAUSensorChange < 0 ? 'down' : ''}
          growth={cvm.MAUSensorChange == 0 ? '-' : formatPercentNum(cvm.MAUSensorChange)}
        />
      ),
    },
    {
      key: 'mainGenre',
      header: formatMessage({ id: 'dbi_main_genre' }),
      width: 140,
      align: 'right',
      render: (cvm: any) => formatGenreColumnValue(cvm.mainGenreDisplay, cvm.mainGenre),
    },
    {
      key: 'subGenre',
      header: formatMessage({ id: 'dbi_sub_genre' }),
      width: 160,
      align: 'right',
      render: (cvm: any) => formatGenreColumnValue(cvm.subGenreDisplay, cvm.subGenre),
    },
    {
      key: 'settings',
      header: formatMessage({ id: 'dbi_actions' }),
      align: 'right',
      width: 120,
      render: (cvm: any) => {
        return (
          <Button
            type="link"
            onClick={() => {
              gotoGameDetailsPage(cvm);
            }}
          >
            {formatMessage({ id: 'dbi_details' })}
          </Button>
        );
      },
    },
  ];

  const columns = [
    {
      key: 'select',
      width: 37,
      fixed: 'left',
      header: () => {
        return (
          <TableCheckboxHeader
            selectList={selectedKeys}
            tableSelectionAll={selectedAllKeys}
            onChange={(list, type) => {
              if (type == 'all') return;
              changeSelectedKeysColor({});
              selectedKeys.length = 0;
              changeSelectedKeys([...selectedKeys]);
            }}
          />
        );
      },
      render: (cvm: any) => {
        return (
          <TableCheckboxRender
            selectList={selectedKeys}
            cvm={{ ...(cvm || {}), gameId: cvm?.app_id }}
            // allSelectColor={selectedKeysColor}
            onChange={(list, status) => {
              changeSelectedKeys(list);
              const selectedKeysColorTemp = [] as any;

              list.forEach((item, index) => {
                if (list.length < 6) {
                  let itemColor = '';
                  if (gameType == 'mobile') {
                    itemColor = color[index];
                  } else {
                    itemColor = pcColor[index];
                  }
                  selectedKeysColorTemp[item.app_id] = itemColor;
                }
              });
              changeSelectedKeysColor(selectedKeysColorTemp);
            }}
          />
        );
      },
    },
    {
      width: 300,
      key: 'id',
      header: (
        <div className="dbi-firstRow-flex">
          <span className="dbi-text-id">#</span>
          <span>{formatMessage({ id: 'dbi_game' })}</span>
        </div>
      ),
      fixed: 'left',
      render: (cvm: any) => (
        <FirstRow
          id={cvm.rank}
          cvm={{
            imgType: gameType,
            gametitle: cvm.name,
            img: cvm.gameIcon,
            countryIcon: cvm.conutryFlag || defaltCountryImg,
            // 这里之前展示的是城市+国家，240712胡政确认要求改为跟mobile一致，显示发行商
            text: cvm.desc,
            icon: cvm.platList?.map((obj: any) => {
              if (obj.toUpperCase() == 'PS') return playstation;
              if (obj.toUpperCase() == 'XBOX') return xbox;
              if (obj.toUpperCase() == 'NINTENDO') return nintendo;

              return '';
            }),
          }}
          onClick={() => gotoGameDetailsPage(cvm)}
          rihgtClickToJumpHref={gotoGameDetailsPage(cvm, false)}
        />
      ),
    },
    {
      key: 'DigitalRevenue',
      align: 'right',
      header: (
        <CloumsCenter width={260} align={'right'}>
          <SortBy
            // type="font_sort"
            title={formatMessage({ id: 'dbi_metric_digitalRevenue' })}
            svgIcon={mscience32}
            filter={changeTableSort}
            defaultKey={sortColunms[0]}
            defaultValue={sortOrder?.[sortColunms[0]] || 'desc'}
            onChange={onGamesSortChange}
            svgTip={
              <DataSourceBubbleContent
                sourceNameLocalId={formatMessage({
                  id: 'dbi_metric_digitalRevenue',
                })}
                metric={'mscience'}
                metricKey={'digitalRevenue'}
                entityType={gameType}
              />
            }
            content={formatMessage({ id: 'dbi_info_sum_selected' })}
            list={[
              {
                key: `gameRevenueD`,
                text: formatMessage({ id: 'dbi_revenue_$' }),
                title: formatMessage({ id: 'dbi_metric_digitalRevenue' }),
              },
              {
                key: `gameRevenueDChange`,
                text: `${formatMessage({ id: 'dbi_revenue_$' })}:${formatMessage({
                  id: 'dbi_change',
                })}(%)`,
                title: `${formatMessage({ id: 'dbi_metric_digitalRevenue' })}%`,
              },
            ]}
          />
        </CloumsCenter>
      ),
      render: (cvm: any) => (
        <CloumsCenter width={260} align={'right'}>
          <TableShowData
            value={cvm.revenueDigital == 0 ? '-' : formatNum(cvm.revenueDigital, true)}
            type={cvm.revenueDigitalChange > 0 ? 'up' : cvm.revenueDigitalChange < 0 ? 'down' : ''}
            growth={
              cvm.revenueDigitalChange == 0 ? '-' : formatPercentNum(cvm.revenueDigitalChange)
            }
          />
        </CloumsCenter>
      ),
    },
    {
      key: 'PhysicalRevenue',
      align: 'right',
      header: (
        <CloumsCenter width={260} align={'right'}>
          <SortBy
            // type="font_sort"
            title={formatMessage({ id: 'dbi_metric_physical_revenue' })}
            svgIcon={npd}
            filter={changeTableSort}
            defaultKey={sortColunms[0]}
            defaultValue={sortOrder?.[sortColunms[0]] || 'desc'}
            onChange={onGamesSortChange}
            svgTip={
              <DataSourceBubbleContent
                sourceNameLocalId={formatMessage({
                  id: 'dbi_metric_physical_revenue',
                })}
                metric={'npd'}
                metricKey={'physical_revenue'}
                entityType={gameType}
              />
            }
            content={formatMessage({ id: 'dbi_info_sum_selected' })}
            list={[
              {
                key: `gameRevenueP`,
                text: formatMessage({ id: 'dbi_revenue_$' }),
                title: formatMessage({ id: 'dbi_metric_physical_revenue' }),
              },
              {
                key: `gameRevenuePChange`,
                text: `${formatMessage({ id: 'dbi_revenue_$' })}:${formatMessage({
                  id: 'dbi_change',
                })}(%)`,
                title: `${formatMessage({ id: 'dbi_metric_physical_revenue' })}%`,
              },
            ]}
          />
        </CloumsCenter>
      ),
      render: (cvm: any) => (
        <CloumsCenter width={260} align={'right'}>
          <TableShowData
            value={cvm.revenuePhysical == 0 ? '-' : formatNum(cvm.revenuePhysical, true)}
            type={cvm.revenueSensorChange > 0 ? 'up' : cvm.revenueSensorChange < 0 ? 'down' : ''}
            growth={
              cvm.revenuePhysicalChange == 0 ? '-' : formatPercentNum(cvm.revenuePhysicalChange)
            }
          />
        </CloumsCenter>
      ),
    },
    {
      key: 'MAU',
      align: 'right',
      header: (
        <CloumsCenter width={200} align={'right'}>
          <SortBy
            // type="font_sort"
            title={
              dateType == 'month'
                ? formatMessage({ id: 'dbi_mau' })
                : dateType == 'week'
                ? formatMessage({ id: 'dbi_wau' })
                : formatMessage({ id: 'dbi_dau' })
            }
            svgIcon={newzoo}
            filter={changeTableSort}
            defaultKey={sortColunms[0]}
            defaultValue={sortOrder?.[sortColunms[0]] || 'desc'}
            onChange={onGamesSortChange}
            svgTip={
              <DataSourceBubbleContent
                sourceNameLocalId={`AVG ${
                  dateType == 'month'
                    ? formatMessage({ id: 'dbi_mau' })
                    : dateType == 'week'
                    ? formatMessage({ id: 'dbi_wau' })
                    : formatMessage({ id: 'dbi_dau' })
                }`}
                metric={'newzoo'}
                metricKey={'mau'}
                entityType={gameType}
              />
            }
            content={formatMessage({ id: 'dbi_info_avg_selected' })}
            list={[
              {
                key: `MAU`,
                text:
                  dateType == 'month'
                    ? formatMessage({ id: 'dbi_mau' })
                    : dateType == 'week'
                    ? formatMessage({ id: 'dbi_wau' })
                    : formatMessage({ id: 'dbi_dau' }),
                title:
                  dateType == 'month'
                    ? formatMessage({ id: 'dbi_mau' })
                    : dateType == 'week'
                    ? formatMessage({ id: 'dbi_wau' })
                    : formatMessage({ id: 'dbi_dau' }),
              },
              {
                key: `MAUChange`,
                text: `${
                  dateType == 'month'
                    ? formatMessage({ id: 'dbi_mau' })
                    : dateType == 'week'
                    ? formatMessage({ id: 'dbi_wau' })
                    : formatMessage({ id: 'dbi_dau' })
                }:${formatMessage({ id: 'dbi_change' })}(%)`,
                title: `${
                  dateType == 'month'
                    ? formatMessage({ id: 'dbi_mau' })
                    : dateType == 'week'
                    ? formatMessage({ id: 'dbi_wau' })
                    : formatMessage({ id: 'dbi_dau' })
                }(%)`,
              },
            ]}
          />
        </CloumsCenter>
      ),
      render: (cvm: any) => (
        <CloumsCenter width={200} align={'right'}>
          <TableShowData
            value={cvm.MAU == 0 ? '-' : formatNum(cvm.MAU, true)}
            type={cvm.MAUChange > 0 ? 'up' : cvm.MAUChange < 0 ? 'down' : ''}
            growth={cvm.MAUChange == 0 ? '-' : formatPercentNum(cvm.MAUChange)}
          />
        </CloumsCenter>
      ),
    },
    {
      key: 'mainGenre',
      align: 'right',
      width: 200,
      header: formatMessage({ id: 'dbi_main_genre' }),
      render: (cvm: any) => formatGenreColumnValue(cvm?.mainGenreDisplay, cvm?.mainGenre),
    },
    {
      key: 'subGenre',
      align: 'right',
      width: 260,
      header: formatMessage({ id: 'dbi_sub_genre' }),
      render: (cvm: any) => formatGenreColumnValue(cvm?.subGenreDisplay, cvm?.subGenre),
    },
    {
      key: 'settings',
      header: formatMessage({ id: 'dbi_actions' }),
      width: 150,
      align: 'right',
      render: (cvm: any) => {
        return (
          <Button
            type="link"
            onClick={() => {
              gotoGameDetailsPage(cvm);
            }}
          >
            {formatMessage({ id: 'dbi_details' })}
          </Button>
        );
      },
    },
  ];
  return (
    <Table
      className="tablecard-box dbi-table-selectable dbi-table-sticky"
      bordered="all"
      records={showTableData}
      columns={gameType === 'mobile' ? tableColumns : columns}
      topTip={
        tableDataLoad ? (
          <div style={{ height: 425 }}>
            <Loading content={formatMessage({ id: 'common_loading' })} />
          </div>
        ) : (
          ''
        )
      }
      addons={[
        scrollable({
          minWidth: 1800,
        }),
        pageable({
          recordCount: dataType == 'game' ? tableLength : showTableData?.length || 0,
          isPagingReset: true,
          stateText: `Total items: ${
            dataType == 'game' ? tableLength : showTableData?.length || 0
          }`,
          pageSizeOptions: dataType == 'operation' ? [5, 10, 20] : [10, 20, 50],
          // pageCountChangingResetType: 'last',
          pageSize,
          pageIndex,
          onPagingChange,
        }),
      ]}
    />
  );
}
